import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const PassportDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Passport Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>Passport Number</th>
                  {/* <th>Description</th> */}
                  <th>Issued Date</th>
                  <th>Issued Place</th>
                  <th>Expiry Date</th>
                  {/* <th>Passport Number</th> */}
                </tr>
              </thead>
              <tbody>
                {employee?.documentImageDetails?.map((pass) => (
                  <tr key={pass?.code}>
                    <td>{pass?.passportNumber}</td>
                    {/* <td>{pass?.description}</td> */}
                    <td>{pass?.issuedDate && format(new Date(pass?.issuedDate), "yyyy-MM-dd")}</td>
                    <td>{pass?.issuedPlace}</td>
                    <td>{pass?.expiryDate && format(new Date(pass?.expiryDate), "yyyy-MM-dd")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* <div className="row">
          {employee?.documentImageDetails?.[0]?.frontImage !== null &&
            employee?.documentImageDetails?.[0]?.frontImage !== "" && (
              <div className="col-md-6">
                <div className="slider-product-details">
                  <div className="owl-carousel owl-theme product-slide">
                    <div className="slider-product">
                      <img
                        src={employee?.documentImageDetails?.[0]?.frontImage}
                        alt="Pass Front Image"
                        width={60}
                      />
                      <h4>Front Image</h4>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {employee?.documentImageDetails?.[0]?.backImage !== null &&
            employee?.documentImageDetails?.[0]?.backImage !== "" && (
              <div className="col-md-6">
                <div className="slider-product-details">
                  <div className="owl-carousel owl-theme product-slide">
                    <div className="slider-product">
                      <img
                        src={employee?.documentImageDetails?.[0]?.backImage}
                        alt="Pass Back Image"
                        width={60}
                      />
                      <h4>Back Image</h4>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div> */}
      </div>
    </div>
  );
};

PassportDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default PassportDetails;
